// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { AgressorFlagType } from '../../Utils/Enums/Constants.js'
import { DirectMessageBase } from './DirectMessageBase.ts'
import { DirectMessageCode } from './DirectMessageCodes.ts'
import { DirectQuoteMessage } from './DirectQuoteMessage.js'
export let DirectQuote3Message = function ()
{
    DirectQuoteMessage.call(this, DirectMessageCode.CODE_QUOTE_3)
    this.Type = DirectQuoteMessage.QUOTE_TRADES
    this.Exchange = null
    this.Price = Number.NaN
    this.Size = Number.NaN
    this.OpenInterest = null
    this.BuyerSource = null
    this.SellerSource = null
    this.BuyerSourceId = 0
    this.SellerSourceId = 0
    this.LastVenue = null
    // оно же аггрессор флаг -1-роут не ставит, 0-бай, 1-селл
    this.LType = AgressorFlagType.NotSet
}

DirectQuote3Message.prototype = Object.create(DirectQuoteMessage.prototype)